import { images } from "@/assets";
import {
  DataTableCollapsibleRow,
  FormSectionHeader,
  Loader,
} from "@/components";
import { cn } from "@/lib/utils";
import usePropertyReport from "./usePropertyReport";
import { Button, Input } from "@/components/ui";

const PropertyReport = ({ reportDate }: { reportDate: any }) => {
  const {
    summaryCard,
    columns,
    isLoadingDetailedReport,
    subColumns,
    onRowExpanded,
    tableData,
    searchValue,
    onSearch,
    onClear,
    onChangeText,
  } = usePropertyReport({ reportDate });
  return (
    <>
      {isLoadingDetailedReport ? (
        <Loader />
      ) : (
        <>
          <div className="bg-white mt-[10px] rounded-lg px-[30px] py-[20px] mb-6 shadow-sm">
            <div className="flex flex-row gap-3 items-start justify-start">
              <FormSectionHeader>Overall Summary</FormSectionHeader>
            </div>

            <div className="bg-primary rounded-sm grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
              {summaryCard?.map((data: any, index: number) => (
                <div
                  className={cn(
                    "flex flex-row md:items-center lg:justify-center text-white my-7 mx-4 gap-3",
                    index !== summaryCard.length - 1 ? "lg:border-r-1" : ""
                  )}
                  key={`ar-summary-card-${index}`}
                >
                  <div className="bg-white p-3 rounded-full">
                    <img src={images.check_doc} className="h-8 w-8" />
                  </div>
                  <div className="flex flex-col text-[14px]">
                    <span>
                      {data?.title} : {data?.count || 0}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white mt-[10px] rounded-lg p-[20px]">
            <div className="flex flex-row items-start justify-between mb-4">
              <FormSectionHeader>Report</FormSectionHeader>
              <div className="flex flex-row w-[40%] gap-4">
                <div className="relative w-[90%]">
                  <Input
                    onChange={(e) => onChangeText(e.target.value)}
                    placeholder="Search By Property Name"
                    value={searchValue}
                  />
                </div>
                <Button onClick={onSearch}>Search</Button>
                <Button onClick={onClear} variant="outline">
                  Clear
                </Button>
              </div>
            </div>

            <DataTableCollapsibleRow
              columns={columns}
              nestedColumns={[subColumns]}
              data={tableData || []}
              onExpand={onRowExpanded}
            />
          </div>
        </>
      )}
    </>
  );
};

export default PropertyReport;
